import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

import themes from 'devextreme/ui/themes';

// import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles.css";

export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}

const providers = [
  { provide: "BASE_URL", useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

themes.initialized(() => {
  platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.error(err));
});

config({ licenseKey });
